module.exports = __webpack_public_path__ + "img/focus-qrcode.85019fdb.png";